import { ImpresionAdjuntoConfig, PagoConfig, PagoReciboConfig, ErrorConfig, BasicConfig, EnvioCorreoConfig } from './emision.service.config';

import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { Configuration, Encrypted } from '../Constants/configuration';
import { StorageService } from './storage.service';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { NotificacionService } from './notificacion.service';
import { RequestServices } from './request.service';
interface IResponse {
    response: boolean,
    message: string,
    other?: any
}
@Injectable()
export class EmisionService {
    private DEFAULT_URL: string;
    private S4_KEY: string;
    private CONFIG: Configuration;
    private IS_DEBUG: boolean;
    private impresionSubject = new Subject<boolean>();
    private loaderSubject = new BehaviorSubject({ response: true, message: 'initial' });
    private isImpresionAsync = false;
    private basicConfing: BasicConfig;
    private ciaString: string;
    private flagSendPoliza = 0;
    //public cias: Cias = new Cias();
    public tryGoHome = new EventEmitter();
    //public printRelease = new EventEmitter();
    private hasCanceller = false;
    private hasPay = false;
    private storageService: StorageService = new StorageService();
    private cocheSeguro: CocheSeguro = new CocheSeguro();
    private modeloCorreo: number;

    public notificacionService: NotificacionService = new NotificacionService(this.requestServices);
    private contadorMapfre = 0;

    constructor(private http: HttpClient, private requestServices: RequestServices) {
        this.CONFIG = new Configuration();
        this.S4_KEY = this.CONFIG.S4_KEY;
        this.DEFAULT_URL = this.CONFIG.URL;
        this.IS_DEBUG = this.CONFIG.IS_DEBUG;
        if (this.storageService.ifExist("cocheSeguro")) {
            this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            switch (this.cocheSeguro.paquete) {
                case 0: // AMPLIA
                    this.modeloCorreo = 23;
                    break;
                case 1: // LIMITADA
                    this.modeloCorreo = 24;
                    break;
                case 2: // BÁSICA
                    this.modeloCorreo = 24;
                    break;
                /// verificar que tipo de modelo se enviara al cliente -- metodoPago()
            }
        }
    }

    generaPagoConTarjeta(config: PagoConfig, ejecPrimerPago?: boolean, primerRecibo?: string) {
        try {
            this.basicConfing = config.basic;
            this.hasCanceller = config.hasCanceller;

            const pago = {
                emision_id: config.basic.emisionId,
                neg_id: config.negocioId,
                cia: config.basic.ciaId,
                noPoliza: config.basic.noPoliza,
                noTarjeta: config.tarjeta.c4,
                tipoTarjeta: config.tarjeta.c8 + '',
                cvn: config.tarjeta.c6,
                fecVenc: config.tarjeta.c5 + config.tarjeta.c7,
                nombreCompleto: (config.tarjeta.c3 + ' ' + config.tarjeta.c3A + ' ' + config.tarjeta.c3B).trim(),
                email: config.email,
                url: config.url,
            }

            switch (config.basic.ciaId) {
                case 18:
                    if (config.total) {
                        pago["mac"] = config.total;
                    }
                    break;
                case 22:
                    if (config.formaPago == 'A' && config.tarjeta.c13 == '1') {
                        pago['modalidad'] = config.tarjeta.c12;
                    }
                    pago['idBanco'] = config.tarjeta.c1;
                    pago['montRec'] = /*'1.00'*/config.total;//Pruebas un peso
                    pago['tipoTarjeta'] = config.tarjeta.c9;
                    pago['modalidad'] = config.tarjeta.c12;
                    break;
                case 29:
                    if (config.formaPago == 'A' && config.tarjeta.c13 == '1') {
                        pago['modalidad'] = config.tarjeta.c12;
                    }
                    //let fecCancelacion = new Date();
                    //pago['fecCancelacion'] = fecCancelacion.getDate().toString().length < 2 ? '0' + fecCancelacion.getDate() : fecCancelacion.getDate().toString();
                    pago['formaPago'] = config.formaPago;
                    pago['idBanco'] = config.tarjeta.c1;
                    pago['banco'] = config.tarjeta.c2;
                    pago['rfc'] = config.tarjeta.c3C;
                    pago['tipoCuenta'] = config.tarjeta.c13;
                    pago['cocheSeguro'] = 1;
                    break;
                case 49:
                    pago['banco'] = config.tarjeta.c1;
                    if (!ejecPrimerPago) {
                        if (config.formaPago == 'A') {
                            if (config.tarjeta.c13 == '1') {
                                pago['modalidad'] = config.tarjeta.c12;
                            }
                        } else {
                            let fecPrimerCargo = new Date();
                            fecPrimerCargo.setDate(fecPrimerCargo.getDate() + 5);
                            pago['fecPriCar'] = fecPrimerCargo.getDate().toString().length < 2 ? '0' + fecPrimerCargo.getDate() : fecPrimerCargo.getDate().toString();
                            pago['tipoTarjeta'] = config.tarjeta.c13 == '1' ? '0' : '03';
                        }
                    } else {
                        pago['numRec'] = primerRecibo;
                    }
                    break;
                default:
                    break;
            }

            switch (config.escenario) {
                case 0:
                    this.postRequest({ projectName: this.CONFIG.URLQUATTROAUTOSWS, apiName: 'PagoEnLinea', dataJSON: { 'pago': pago } })
                        .subscribe(
                            result => {
                                if (result.error) {
                                    this.notificacionService.notificacionCRM({
                                        url: this.cocheSeguro.url, aseguradoraID: config.basic.ciaId, clienteID: config.basic.clienteId, noPoliza: config.basic.noPoliza, emisionID: config.basic.emisionId.toString(), msgError: result.error
                                    });
                                    if (ejecPrimerPago) {
                                        this.cancelaDomiciliacion({ emision_id: config.basic.emisionId, neg_id: config.negocioId, cia: config.basic.ciaId, noPoliza: config.basic.noPoliza });
                                    } else {
                                        this.tryGoHome.emit({ response: false, message: result.error, position: 1 });
                                    }
                                    //this.revisionCancelacionPoliza(config, result.error);
                                    //this.notificaFallaPagoEnLinea(config.polizaId, config.worksiteId);
                                } else {
                                    /**Sección para realizar el pago del recibo */
                                    if (config.basic.ciaId === 1 || config.basic.ciaId === 18) {
                                        window.location.href = result.url;
                                    } else {
                                        let configPago: PagoReciboConfig = {
                                            reciboId: config.reciboId,
                                            base: config.basic,
                                            total: config.total,
                                            documento: result.documento,
                                            formaCobro: result.formaCobro,
                                            comentario: result.comentario != undefined ? result.comentario : '',
                                            fecPago: result.fecPago
                                        };

                                        this.notificacionService.notificacionCRM({
                                            url: this.cocheSeguro.url, aseguradoraID: this.cocheSeguro.cia, msgError: JSON.stringify(configPago)
                                        });

                                        let configPagoComplemento: PagoReciboConfig = {
                                            reciboId: config.recIdComplemento,
                                            base: config.basic,
                                            total: '0',
                                            documento: '',
                                            formaCobro: 1,
                                            comentario: '',
                                            fecPago: undefined
                                        };

                                        this.notificacionService.notificacionCRM({
                                            url: this.cocheSeguro.url, aseguradoraID: this.cocheSeguro.cia, msgError: JSON.stringify(configPagoComplemento)
                                        });

                                        switch (config.basic.ciaId) {
                                            case 22:
                                                configPago['liquidacion'] = result.num_autorizacion.toString();
                                                break;
                                            default:
                                                configPago['liquidacion'] = result.liquidacion.toString();
                                                break;
                                        }

                                        if (config.formaPago == 'A') {
                                            if (result.status === 1) {
                                                this.hasPay = true;
                                                this.tryGoHome.emit({ response: true, message: 'OK', position: 0 });
                                                this.generaPagoPrimerRecibo(configPago);
                                                this.generaPagoPrimerRecibo(configPagoComplemento);
                                            } else if (result.result === 'Unimplemented cia') {
                                                this.tryGoHome.emit({ response: true, message: 'OK', position: 0 });
                                            }
                                        } else {
                                            switch (config.basic.ciaId) {
                                                case 49:
                                                    /**Despues de domiciliar la tarjeta procedemos a realizar el primer pago */
                                                    if (ejecPrimerPago) {
                                                        this.hasPay = true;
                                                        this.tryGoHome.emit({ response: true, message: 'OK', position: 0 });
                                                        this.generaPagoPrimerRecibo(configPago);
                                                        this.generaPagoPrimerRecibo(configPagoComplemento);
                                                    } else {
                                                        this.pagarPrimerReciboCia(config, (result.num_rec != undefined ? result.num_rec : ''));
                                                    }
                                                    break;
                                                default:
                                                    this.hasPay = true;
                                                    this.tryGoHome.emit({ response: true, message: 'OK', position: 0 });
                                                    this.generaPagoPrimerRecibo(configPago);
                                                    this.generaPagoPrimerRecibo(configPagoComplemento);
                                                    break;
                                            }
                                        }
                                    }
                                }
                            }, error => {
                                this.notificacionService.notificacionCRM({
                                    url: this.cocheSeguro.url, aseguradoraID: config.basic.ciaId, clienteID: config.basic.clienteId, noPoliza: config.basic.noPoliza, emisionID: config.basic.emisionId.toString(), msgError: error
                                });
                                this.tryGoHome.emit({ response: false, message: error, position: 1 });
                                //this.revisionCancelacionPoliza(config, error);
                                //this.notificaFallaPagoEnLinea(config.polizaId, config.worksiteId);
                                //this.generaCRM('Aviso Pago ', this.erroGenerator(error));
                            }
                        );
                    break;
                case 1: // exitosos
                    setTimeout(() => {
                        let configPago: PagoReciboConfig = {
                            reciboId: config.reciboId,
                            base: config.basic,
                            total: config.total,
                            documento: "Prueba emision",
                            formaCobro: 1,
                            comentario: "Escenario positivo de pago",
                            fecPago: this.format(new Date(), true)
                        };

                        let configPagoComplemento: PagoReciboConfig = {
                            reciboId: config.recIdComplemento,
                            base: config.basic,
                            total: '0',
                            documento: 'Prueba emision',
                            formaCobro: 1,
                            comentario: 'Escenario positivo de pago',
                            fecPago: undefined
                        };

                        this.hasPay = true;
                        this.tryGoHome.emit({ response: true, message: 'OK', position: 0 });
                        this.generaPagoPrimerRecibo(configPago);
                        this.generaPagoPrimerRecibo(configPagoComplemento);
                    }, 800);



                    break;
                case 2: // negativo
                    setTimeout(() => {
                        this.tryGoHome.emit({ response: false, message: "Escenario negativo de pago", position: 1 });
                    }, 800);

                    break;
            }
        } catch (ex) {
            this.notificacionService.notificacionCRM({
                url: this.cocheSeguro.url, aseguradoraID: config.basic.ciaId, clienteID: config.basic.clienteId, noPoliza: config.basic.noPoliza, emisionID: config.basic.emisionId.toString(), msgError: ex
            });
            //this.generaCRM('Aviso Pago ', this.erroGenerator(ex));
            this.tryGoHome.emit({ response: false, message: ex, position: 1 });
            console.error('error catch: ', ex);
            //this.revisionCancelacionPoliza(config, ex);
            //this.notificaFallaPagoEnLinea(config.polizaId, config.worksiteId);
        }
    }

    pagarPrimerReciboCia(config: PagoConfig, primerRecibo: string) {
        this.generaPagoConTarjeta(config, true, primerRecibo);
    }

    cancelaDomiciliacion(cancela: CancelaDomiciliacion) {
        try {
            this.postRequest({ projectName: new Configuration().URLQUATTROAUTOSWS, apiName: 'CancelacionDomiciliacion', dataJSON: cancela }).subscribe(
                result => {
                    if (result.error) {
                        this.tryGoHome.emit({ response: false, message: 'Error en la ejecución del pago.', position: 1 });
                        console.error('error: ', result.error);
                    } else {
                        this.tryGoHome.emit({ response: false, message: 'Error en la ejecución del pago.', position: 1 });
                    }
                }, error => {
                    this.tryGoHome.emit({ response: false, message: 'Error en la ejecución del pago.', position: 1 });
                    console.error('error: ', error);
                }
            )
        } catch (ex) {
            this.tryGoHome.emit({ response: false, message: 'Error en la ejecución del pago.', position: 1 });
            console.error('error catch: ', ex);
        }
    }

    /*revisionCancelacionPoliza(config: PagoConfig, mssg: string) {
        try {
            if (config.hasCanceller) {
                const data = {
                    v1: config.polizaId,
                    v2: 'Fallo de pago en linea: ' + mssg + '\n',
                    v3: 'Cancelación por sistema en caso de fallos.',
                    v4: this.encryptConstant.ZERO,
                    v5: config.basic.worksiteId,
                    v6: 0
                };

                this.postRequest(this.constant.URLPolizas, 'MarketCancelacionAutoAPI', data)
                    .subscribe(result => {
                        if (result.error) {
                            console.error('error: ', result);
                            this.tryGoHome.emit({ response: false, message: 'error: ' + result });
                        } else {
                            if (result.ws) {
                                // se hace el proceso de llamada al webservice cambiar bandera a 1 despues del ws
                                if (result.datosWS.c1 > 0 && result.datosWS.c2 !== '' && result.datosWS.c3 !== '') {
                                    let _url = '';
                                    switch (config.basic.ciaId) {
                                        case 31: case 29:
                                            _url = this.constant.URLQuattroAutosWS;
                                            break;
                                        default:
                                            _url = this.constant.URLQuattroAutos;
                                            break;
                                    }

                                    try {
                                        const _dataWs = {
                                            cia: config.basic.ciaId,
                                            negocio_id: result.datosWS.c1,
                                            no_poliza: (config.basic.ciaId === 29 ? config.movimiento : config.polizaId),
                                            fecIniVigEndoso: result.datosWS.c3,
                                            amis: (config.amis ? config.amis : '')
                                        };

                                        this.postRequest(_url, 'cancelarPoliza', _dataWs)
                                            .subscribe(
                                                resultCancelaWS => {
                                                    if (resultCancelaWS.error) {
                                                        console.error('result.error: ', resultCancelaWS.error);
                                                        this.tryGoHome.emit({ response: false, message: 'error: ' + resultCancelaWS.error });
                                                        // tslint:disable-next-line: max-line-length
                                                        this.generaCRM('Aviso de WS Cancelación ' + this.cias.alias(config.basic.ciaId), this.erroGenerator(resultCancelaWS.error));

                                                        data.v6 = 1;

                                                        this.postRequest(this.constant.URLPolizas, 'MarketCancelacionAutoAPI', data)
                                                            .subscribe(
                                                                resultCancela => {
                                                                    if (resultCancela.error) {
                                                                        console.error('result.error2: ', resultCancela.error);
                                                                        this.tryGoHome.emit({ response: false, message: 'error: ' + resultCancela.error });
                                                                    } else {
                                                                        this.tryGoHome.emit({ response: true, message: 'OK' });
                                                                    }
                                                                }, error => {
                                                                    console.error('error en cancelación de segunda');
                                                                    this.tryGoHome.emit({ response: false, message: 'error cancelación segunda: ' + error });
                                                                }
                                                            );

                                                    } else {
                                                        // tslint:disable-next-line: max-line-length
                                                        this.generaCRM('Aviso de WS Cancelación Exitosa ' + this.cias.alias(config.basic.ciaId), this.erroGenerator('Se canceló la póliza ' + result.datosWS.c2 + '\nServicio: CancelarPoliza'));

                                                        data.v6 = 1;

                                                        this.postRequest(this.constant.URLPolizas, 'MarketCancelacionAutoAPI', data)
                                                            .subscribe(
                                                                resultCancela => {
                                                                    if (resultCancela.error) {
                                                                        console.error('result.error2: ', resultCancela.error);
                                                                        this.tryGoHome.emit({ response: false, message: 'error: ' + resultCancela.error });
                                                                    } else {
                                                                        this.tryGoHome.emit({ response: true, message: 'OK' });
                                                                    }
                                                                }, error => {
                                                                    console.error('error en cancelación de segunda');
                                                                    this.tryGoHome.emit({ response: false, message: 'error cancelación segunda: ' + error });
                                                                }
                                                            );
                                                    }
                                                }, error => {
                                                    console.error('error en cancelación por ws');
                                                    this.tryGoHome.emit({ response: false, message: 'error cancelación por ws: ' + error });
                                                }
                                            );
                                    } catch (ex) {
                                        console.error('exception en cancelación por ws');
                                        this.tryGoHome.emit({ response: false, message: 'error cancelación por ws: ' + ex });
                                    }
                                } else {
                                    console.error('Datos incompletos para hacer cancelación');
                                }
                            }
                        }
                    }, error => {
                        console.error('Error => ', error);
                    });
            }
        } catch (ex) {
            console.error('error: ', ex);
        }
    }*/

    generaImpresionAdjuntoAsync(config: ImpresionAdjuntoConfig): Observable<any> {
        this.isImpresionAsync = true;
        this.generaImpresionAdjunto(config);
        return this.impresionSubject.asObservable();
    }

    getPrintResponseAsync(): Observable<IResponse> {
        return this.loaderSubject.asObservable();
    }

    generaImpresionAdjunto(config: ImpresionAdjuntoConfig) {
        let medioPago: boolean = config?.medioPago || true;
        this.basicConfing = config.basic;
        const data = [{ 'emision_id': config.basic.emisionId }];
        data.push.apply(data, [{ 'emisionID': config.basic.emisionId }]);
        data.push.apply(data, [{ 'isProd': new Configuration().isProd }]);
        // Verifica si existe la propiedad formaPago, en caso de existir verifica que tambien sea falsa y la integra al objeto data
        if (!config?.medioPago) {
            data.push.apply(data, [{ 'tipoImp': 3 }]);
            data.push.apply(data, [{ 'medioPago': config.medioPago }]);
            medioPago = config.medioPago;
        }

        if (config.basic.noPoliza && config.basic.ciaId != 22) {
            data.push.apply(data, [{ 'poliza': config.basic.noPoliza }]);
        }
        let _url = '';
        let _apiImpresion = 'impresion';
        let _apiLectura = 'LecturaImpresion';
        let _addTkn = false;
        
        switch (config.basic.ciaId) {
            case 7: case 14: case 33: case 44: case 49: case 88: case 35: case 22: case 18:
                _url = this.CONFIG.URLQUATTROAUTOSWS;
                break;
            case 20: case 31:
                _url = new Configuration().URLQUATTROAUTO;
                _apiImpresion = 'publics/impresion';
                _apiLectura = 'lecturaImpresion';
                _addTkn = true;
                break;
            default:
                _url = this.CONFIG.URLQUATTROAUTOS;
                break;
        }
        if (config.basic.ciaId === 22) {
            data.push.apply(data, [{ 'no_endoso': '0' }]);
            this.contadorMapfre++;
        }
        this.getRequest({ projectName: _url, apiName: _apiImpresion, params: data, bearer: _addTkn }).subscribe(
            resultImpresion => {
                if (resultImpresion.error) {
                    this.notificacionService.notificacionCRM({
                        url: this.cocheSeguro.url, aseguradoraID: config.basic.ciaId, clienteID: config.basic.clienteId, noPoliza: config.basic.noPoliza, emisionID: config.basic.emisionId.toString(), cotizacionID: config.cotizacionId.toString(), msgError: resultImpresion.error
                    });
                    if (config.basic.ciaId === 22 && this.contadorMapfre <= 3) {
                        this.generaImpresionAdjunto(config);
                    } else {
                        // tslint:disable-next-line: max-line-length
                        //this.generaCRM('Aviso Impresión ', this.erroGenerator(resultImpresion.error, { conductor: config.conductor }));
                        if (config.basic.ciaId === 22 && medioPago != undefined) {
                            let tipoEmision: number = 1; // con pago
                            if (!medioPago) {
                                tipoEmision = 0;// sin pago
                            }
                            this.compartirMiPoliza(config.email, config.polizaId, config.polizaIdComplemento);
                            this.compartirCaraturaPolizaV2(config.polizaId, config.email, this.modeloCorreo);
                            if (this.isImpresionAsync === true) this.impresionSubject.next(false);
                        } else {
                            if (this.isImpresionAsync === true) this.impresionSubject.next(false);
                        }
                        //this.loaderSubject.next({ response: false, message: resultImpresion.error });
                    }
                } else {
                    if ((resultImpresion.respuesta && resultImpresion.respuesta.toLowerCase() === 'ok') || (resultImpresion.result.respuesta && resultImpresion.result.respuesta.toLowerCase() === 'ok')) {
                        this.getRequest({ projectName: _url, apiName: _apiLectura, params: data, bearer: _addTkn })
                            .subscribe(
                                resultLectura => {
                                    if (resultLectura.error) {
                                        this.notificacionService.notificacionCRM({
                                            url: this.cocheSeguro.url, aseguradoraID: config.basic.ciaId, clienteID: config.basic.clienteId, noPoliza: config.basic.noPoliza, emisionID: config.basic.emisionId.toString(), msgError: resultLectura.error
                                        });
                                        // tslint:disable-next-line: max-line-length
                                        //this.generaCRM('Aviso Impresión ', this.erroGenerator(resultLectura.error));
                                        if (this.isImpresionAsync === true) this.impresionSubject.next(false);
                                        //this.loaderSubject.next({ response: false, message: resultLectura.error });
                                    } else {
                                        if (resultLectura && ((resultLectura.impresion && resultLectura.impresion.length > 0) || resultLectura.ok)) {
                                            let index = 0;
                                            let impresiones = [];
                                            if (resultLectura.ok && resultLectura.result) {
                                                impresiones = resultLectura.result;
                                            } else {
                                                impresiones = resultLectura.impresion;
                                            }
                                            for (let pdf of impresiones) {
                                                index++;
                                                setTimeout(() => {
                                                    this.grabaAdjuntos(pdf.pdf, pdf.nombre_original, config.polizaId, config.worksiteEnc, impresiones.length, config.email, config.polizaIdComplemento, medioPago);
                                                }, 500 * index);
                                            }
                                        } else {
                                            if (this.isImpresionAsync === true) this.impresionSubject.next(false);
                                        }
                                        setTimeout(() => {
                                            //this.loaderSubject.next({ response: true, message: '' });
                                        }, 500);
                                    }
                                }, error => {
                                    this.notificacionService.notificacionCRM({
                                        url: this.cocheSeguro.url, aseguradoraID: config.basic.ciaId, clienteID: config.basic.clienteId, noPoliza: config.basic.noPoliza, emisionID: config.basic.emisionId.toString(), msgError: error
                                    });
                                    //this.generaCRM('Aviso Impresión ', this.erroGenerator(error, { conductor: config.conductor }));
                                    if (this.isImpresionAsync === true) this.impresionSubject.next(false);
                                    //this.loaderSubject.next({ response: false, message: error });
                                }
                            );
                    }
                }
            }, error => {
                this.notificacionService.notificacionCRM({
                    url: this.cocheSeguro.url, aseguradoraID: config.basic.ciaId, clienteID: config.basic.clienteId, noPoliza: config.basic.noPoliza, emisionID: config.basic.emisionId.toString(), msgError: error
                });
                //this.generaCRM('Aviso Impresión ', this.erroGenerator(error));
                if (this.isImpresionAsync === true) this.impresionSubject.next(false);
                //this.loaderSubject.next({ response: false, message: error });
            });
    }

    private grabaAdjuntos(datos: any, nombre: string, polizaId: string, worksiteIdEnc: string, adjuntodLength: number, email: string, polizaIdComplemento: string, medioPago?: boolean) {
        const _url: string = datos;
        const newName: string = _url.split('/')[_url.split('/').length - 1];
        const data = {
            'b': this.cocheSeguro[this.CONFIG.PROJECT_KEY],
            'm': '',
            's4_key': '',
            'c1': new Encrypted().ZERO,//'l66xHtlkmi56Uqz3MEYuqw==',// adjuntoId
            'c2': _url,// webpath
            'c3': nombre,// nombre Original 
            'c4': '',
            'c5': '.pdf',// extension
            'c6': newName,// nombreNuevo
            'c7': 'pdf.png',
            'c8': polizaId,// id
            'c9': '2',// opcion
            'c10': new Encrypted().UNO,// modulo Flow
            'c11': new Encrypted().ZERO,// filtroTipo
            'c12': 1 // tipo caratula
        };


        this.postRequest({ projectName: this.CONFIG.URLPOLIZAS, apiName: 'Sio4AdjuntoAPI', dataJSON: data }).subscribe(
            result => {
                if (result.error) {
                    this.notificacionService.notificacionCRM({
                        url: this.cocheSeguro.url, aseguradoraID: this.cocheSeguro.cia, msgError: result.error
                    });
                    // tslint:disable-next-line: max-line-length
                    //this.generaCRM('Aviso registro de Adjunto ' + this.ciaString, this.erroGenerator(result.error));
                    if (this.isImpresionAsync === true) this.impresionSubject.next(false);
                    this.flagSendPoliza++;
                } else {
                    if (result.ok) {
                        this.flagSendPoliza++;
                        // tslint:disable-next-line: max-line-length
                        //const latido = { 'adj': 1, 'ven': result.c5, 'c': result.c6, 'po': result.c7, 'p': this.storageService.getItem('peemid'), 'a': result.c8 };
                        //this.postRequestAES(this.constant.MESSAGING_SERVICE_ENDPOINT_AES + 'acumuladores', { 'latido': JSON.stringify(latido) }).subscribe();

                        if (adjuntodLength === this.flagSendPoliza) {

                            let tipoEmision: number = 1; // con pago

                            if (!medioPago) {
                                tipoEmision = 0;// sin pago
                            }

                            this.flagSendPoliza = 0;
                            if (worksiteIdEnc !== undefined && worksiteIdEnc !== null) {
                                if (this.hasCanceller) {
                                    if (this.hasPay) {
                                        // modeloCorreo => emision sin pago y sea qualitas, primeroS = 47 de lo contrario se envia 48 (no implementar aun)
                                        this.compartirCaraturaPolizaV2(polizaId, email, this.modeloCorreo);
                                    }
                                } else {
                                    this.compartirCaraturaPolizaV2(polizaId, email, this.modeloCorreo);
                                }
                            }
                            if (this.isImpresionAsync === true) this.impresionSubject.next(true);
                        }
                    }
                }
            }, error => {
                this.notificacionService.notificacionCRM({
                    url: this.cocheSeguro.url, aseguradoraID: this.cocheSeguro.cia, msgError: error
                });
                //this.generaCRM('Aviso registro de Adjunto ' + this.ciaString, this.erroGenerator(error));
                if (this.isImpresionAsync === true) this.impresionSubject.next(false);
            }
        );
    }

    enviaMailPoliza(config: EnvioCorreoConfig) {
        if (config.worksiteEnc !== undefined && config.worksiteEnc !== null) {
            if (this.hasCanceller) {
                if (this.hasPay) {
                    this.compartirCaraturaPolizaV2(config.polizaId, config.email, this.modeloCorreo);
                }
            } else {
                this.compartirCaraturaPolizaV2(config.polizaId, config.email, this.modeloCorreo);
            }
        }
    }

    generaPagoPrimerRecibo(config: PagoReciboConfig) {
        try {
            const data: any = {
                'b': 'Tn70v6WYDnjJAVUyVFhp5kfhRGnbDM8zkdGzgtXFT8k=',
                'v1': config.reciboId, // ReciboId
                'v2': ((config.fecPago) ? config.fecPago : this.format(new Date(), true)), // Fecha Pago
                'v3': new Encrypted().NUEVE, // Forma Pago
                'v4': config.total,
                'v5': '1.0000',
                'v6': ((config.comentario) ? config.comentario : ''),
                'v7': ((config.liquidacion) ? config.liquidacion : ''),
                'ga': false
            }

            this.notificacionService.notificacionCRM({
                url: this.cocheSeguro.url, aseguradoraID: this.cocheSeguro.cia, msgError: JSON.stringify(data)
            });
            this.postRequest({ projectName: this.CONFIG.URLPOLIZAS, apiName: 'Sio4AplicarPagoAPI', dataJSON: data }).subscribe(result => {
                if (result.error) {
                    this.notificacionService.notificacionCRM({
                        url: this.cocheSeguro.url, aseguradoraID: this.cocheSeguro.cia, msgError: result.error
                    });
                    //this.generaCRM('Aviso Pago Recibo ' + this.ciaString, this.erroGenerator(result.error));
                }
            });
        } catch (ex) {
            this.notificacionService.notificacionCRM({
                url: this.cocheSeguro.url, aseguradoraID: this.cocheSeguro.cia, msgError: ex
            });
            console.error('Exception: ', ex);
        }
    }

    /** SECCIÓN PARA LOS PROCESOS PRIVADOS COMPARTIDOS */

    // private erroGenerator(msg: any, config?: ErrorConfig): string {
    //     let error = '';
    //     error += '\n' + msg;
    //     error += '\nOrigen: MKP';
    //     if (this.storageService.getItem('nm')) {
    //         error += '\nEmpleado: ' + this.storageService.getItem('nm');
    //     }
    //     if (config) {
    //         if (config.conductor && config.conductor !== '') {
    //             error += '\nConductor: ' + config.conductor;
    //         }
    //     }
    //     error += this.navigatorErrorSelector();

    //     return error;
    // }

    // private generaCRM(asunto: string, mensaje: string) {
    //     const data = {
    //         'v1': this.basicConfing.worksiteId,
    //         'v2': asunto + this.basicConfing.ciaString,
    //         'v3': mensaje,
    //         'v4': { 'c1': this.basicConfing.clienteId }
    //     };

    //     this.postRequest(this.constant.URLQuattroEstructura, 'Sio4CrmLogErroresAPI', data).subscribe(
    //         result => {
    //             if (result.error) {
    //                 console.error(result.error);
    //             }
    //         }, error => {
    //             console.error('Ocurrió un problema durante el proceso', error);
    //         });
    // }

    // private navigatorErrorSelector(): string {
    //     let error = '';
    //     if (navigator) {
    //         error += '\nNav. platform: ' + navigator.platform;
    //         if (navigator.userAgent.indexOf('MSIE') !== -1) {
    //             error += '\nNav. navegador: Internet explorer\'';
    //         } else if (navigator.userAgent.indexOf('Edge') !== -1) {
    //             error += '\nNav. navegador: Microsoft Edge';
    //         } else if (navigator.userAgent.indexOf('Trident') !== -1) {
    //             error += '\nNav. navegador: Internet explorer 11';
    //         } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    //             error += '\nNav. navegador: Firefox';
    //         } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    //             error += '\nNav. navegador: Chrome';
    //         } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    //             error += '\nNav. navegador: Safari';
    //         } else {
    //             error += '\nNav. navegador: ' + navigator.userAgent;
    //         }
    //         error += '\nVersion: ' + this.constant.VERSION_PROYECTO;
    //     }

    //     return error;
    // }

    // validacion para saber si es referencia bancaria, determinar el correo a enviar (modelo)

    // @tipoEmision - v4: 1 = pago con tarjeta 0 = emision sin pago
    compartirCaraturaPoliza(polizaIdEnc: string, worksiteIdEnc: string, email: string, modelo: number, tipoEmision?: number) {
        try {
            this.getRequest({ projectName: this.CONFIG.URLPOLIZAS, apiName: 'Sio4CorreoModeloCocheSeguroAPI', params: [{ v1: polizaIdEnc }, { v2: modelo }, { v4: tipoEmision }] }).subscribe(
                result => {
                    if (result.error) {
                        console.error('Ocurrió un problema durante el proceso', result.error);
                    }
                }, error => {
                    console.error('Ocurrió un problema durante el proceso', error);
                }
            )
        } catch (error) {
            console.error('Ocurrió un problema durante el proceso', error);
        }
    }

    /*compartirCaraturaPoliza(polizaIdEnc: string, worksiteIdEnc: string, email: string, servletN?: string) {
        const data = {
            m: this.cocheSeguro[this.CONFIG.PROJECT_KEY],
            f1: polizaIdEnc,
            f2: worksiteIdEnc,
            email: email,
            tkn: this.cocheSeguro.tkn
        }
        if (servletN) {
            data['f3'] = servletN;
        }
        try {
            this.postRequest({ projectName: this.CONFIG.URLPOLIZAS, apiName: 'MarketCompartirCaratulaPolizaAPI', dataJSON: data }).subscribe(
                result => {
                    if (result.error) {
                        console.error('Ocurrió un problema durante el proceso', result.error);
                    }
                }, error => {
                    console.error('Ocurrió un problema durante el proceso', error);
                }
            )
        } catch (error) {
            console.error('Ocurrió un problema durante el proceso', error);
        }
    }*/

    // notificaFallaPagoEnLinea(polizaIdEnc: string, worksiteIdEnc: string) {
    //     try {
    //         this.postRequest({ projectName: this.CONFIG.URLPOLIZAS, apiName: 'MarketNotificaFallaPagoLineaAPI', dataJSON: { 'm': this.storageService.getItem('m'), f1: polizaIdEnc, f2: worksiteIdEnc }}).subscribe(
    //             result => {
    //                 if (result.error) {
    //                     console.error('Ocurrió un problema durante el proceso', result.error);
    //                 }
    //             }, error => {
    //                 console.error('Ocurrió un problema durante el proceso', error);
    //             }
    //         )
    //     } catch (error) {
    //         console.error('Ocurrió un problema durante el proceso', error);
    //     }
    // }

    getRequest(requestGetConfig: RequestGetConfig): Observable<any> {
        let parameters = '?' + this.CONFIG.PROJECT_KEY + '=' + this.cocheSeguro[this.CONFIG.PROJECT_KEY] + '&';
        if (requestGetConfig.apiName == 'QuattroAutosBuscador') {
            parameters = '?';
        }
        parameters += 's4_key=' + this.S4_KEY + ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');
        if (this.cocheSeguro.tkn) {
            parameters += '&tkn=' + this.cocheSeguro.tkn;
        }
        this.log('getRequest', (requestGetConfig.projectName ? requestGetConfig.projectName : '') + requestGetConfig.apiName + parameters);
        // tslint:disable-next-line: max-line-length
        if (requestGetConfig.bearer) {
            const headers = new HttpHeaders()
            .set("Content-Type", "application/json; charset=utf-8;")
            .set("Authorization", "Bearer " + this.storageService.getItem("bearerTkn"));
            return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters, { headers });
        }
        return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters);
    }

    postRequest(requestPostConfig: RequestPostConfig): Observable<any> {
        // tslint:disable-next-line: max-line-length
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + this.CONFIG.PROJECT_KEY + '=' + this.cocheSeguro[this.CONFIG.PROJECT_KEY] + '&s4_key=' + this.S4_KEY;
        if (requestPostConfig.dataJSON instanceof Array) {
            requestPostConfig.dataJSON[0][this.CONFIG.PROJECT_KEY] = this.cocheSeguro[this.CONFIG.PROJECT_KEY]; //this.storageService.getItem(this.CONFIG.PROJECT_KEY);
            requestPostConfig.dataJSON[0].s4_key = this.S4_KEY;
            if (this.cocheSeguro.tkn) {
                requestPostConfig.dataJSON[0].tkn = this.cocheSeguro.tkn;
            }
        } else {
            requestPostConfig.dataJSON[this.CONFIG.PROJECT_KEY] = this.cocheSeguro[this.CONFIG.PROJECT_KEY]; //this.storageService.getItem(this.CONFIG.PROJECT_KEY);
            requestPostConfig.dataJSON.s4_key = this.S4_KEY;
            if (this.cocheSeguro.tkn) {
                requestPostConfig.dataJSON.tkn = this.cocheSeguro.tkn;
            }
        }
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8;');

        return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), { headers }).pipe(timeout(300000));
    }

    private transformParams(params: any): string {
        let paramString = '';

        if (Array.isArray(params)) {
            for (let param of params) {
                paramString += this.readJSONObject(param);
            }
        } else if (params !== undefined && typeof params === 'object') {
            paramString = this.readJSONObject(params);
        } else {
            this.log('msg', 'dato no definido');
        }

        return paramString;
    }

    private readJSONObject(obj: any): string {
        // tslint:disable-next-line: variable-name
        const _keys = Object.keys(obj);
        let data: string = '';
        for (let _key of _keys) {
            data += '&' + _key + '=' + obj[_key];
        }

        return data;
    }

    private log(evento: string, message?: any) {
        if (this.IS_DEBUG) {
            if (message) {
                console.log(evento, message);
            } else {
                console.log(evento);
            }
        }
    }

    compartirMiPoliza(correo: string, polizaId: string, polizaIdComplemento: string) {
        try {
            let data = {
                v1: correo,
                v2: [{ c1: polizaId, c3: 1 }, { c1: polizaIdComplemento, c3: 1 }],
                v3: 2,
                pid: "0"
            }
            this.postRequest({ projectName: new Configuration().URLMIPOLIZA, apiName: 'MiPolizaCompartePolizasAPI', dataJSON: data }).subscribe(
                result => {
                    if (result.error) {
                        console.error("error => ", result.error);
                    } else {
                        //Ir a mi cuenta
                    }
                }, error => {
                    console.error("error => ", error);
                }
            )
        } catch (error) {
            console.error("error: ", error);
        }
    }

    format(date: Date, prepareBD?: boolean): string {
        let day = date.getDate();
        let month = date.getMonth();
        let year = date.getFullYear();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();
        if (prepareBD) {
            return year + '-' + this._getMonthText(month) + '-' + this._to2digit(day) + ' ' + this._to2digit(hour) + ':' + this._to2digit(minute) + ":" + this._to2digit(second);
        } else {
            return this._to2digit(day) + '/' + this._getMonthText(month) + '/' + year;
        }
    }

    private _to2digit(n: number) {
        return ('00' + n).slice(-2);
    }

    private _getMonthText(month) {
        let meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
        return meses[month];
    }

    updateLogConsumoAyuda(correo: string) {
        try {
            this.requestServices.postRequest({ projectName: this.CONFIG.WEB_DB_AES, apiName: "Sio4ActualizaLogConsumoAyuda", dataJSON: { "v1": correo } }).subscribe(result => {
                if (result.error) {
                    console.log("Exception in uptConsumo", result.error);
                }
            });
        } catch (e) {
            console.log("Exception in <uptConsumo>", e);
        }

    }

    compartirCaraturaPolizaV2(polizaID: string, correo: string, modelo: number) {
        this.requestServices.postRequestJson({
            projectName: this.CONFIG.URLPOLIZAS,
            apiName: "inter/mail-send",
            dataJSON: {
                correo: correo,
                polizaIdEnc: polizaID,
                opcion: modelo,
                portal: 0
            }
        }).subscribe(res => {
            if(res.error) {
                console.error('Ocurrió un problema durante el envio del mail', res.error);
            }
        }, error => {
            console.error('Ocurrió un problema durante el envio del mail', error);
        });
    }

}

export class RequestGetConfig {
    /**URL del proyecto API */
    projectName?: string;
    /**Endpoint */
    apiName: string;
    /**parametros para el api en formato JSON */
    params?: any;
    bearer?: boolean
}

export class RequestPostConfig {
    /**URL del proyecto API */
    projectName?: string;
    /**Endpoint */
    apiName: string;
    /**parametros para el api en formato JSON */
    dataJSON: any;
}

export class CancelaDomiciliacion {
    emision_id: number = 0;
    neg_id: number = 0;
    cia: number = 0;
    noPoliza: string = "";
}


